/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
* Item model for each "despacho"
*/
import React, { Component } from 'react';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import Edit from 'material-ui/svg-icons/content/create';
import Trash from 'material-ui/svg-icons/action/delete';
import Tabulador from 'material-ui/svg-icons/image/grid-on';
import IconButton from 'material-ui/IconButton';
import { EditableInlineV2 } from '../../../components/text';
import { COUNTRY_LIST } from '../../../data/selects';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';
import { Alert } from '../../../components/data-containers';

//Fields goes here, it might corresponds with the names of the props
//you modify on state
const errorsProps = {
    name: [],
    taxId: [],
    phone1: [],
    email1: [],
    street: [],
    externalNumber: [],
    internalNumber: [],
    zipCode: [],
    colony: [],
    city: [],
    municipality: [],
    state: []
};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber
const rules = {
    name: [{ key: 'required', errorText: 'Campo requerido' }],
    taxId: [{ key: 'required', errorText: 'Campo requerido' }],
    phone1: [
        { key: 'required', errorText: 'Campo requerido' },
        { key: 'onlyNumbers', errorText: 'Solo Números' },
        { key: 'validationPhone1', errorText: 'Numero telefonico tiene que ser de 10 digitos' }
    ],
    email1: [
        { key: 'required', errorText: 'Campo requerido' },
        { key: 'validationEmail', errorText: 'Ingrese un correo valido' }
    ],
    street: [{ key: 'required', errorText: 'Campo requerido' }],
    externalNumber: [
        { key: 'required', errorText: 'Campo requerido' }
    ],
    internalNumber: [
        { key: 'required', errorText: 'Campo requerido' }
    ],
    zipCode: [
        { key: 'required', errorText: 'Campo Requerido' },
        { key: 'validationZipCode', errorText: 'Codigo postal tiene que ser meno o igual a 10 digitos' }
    ],
    colony: [{ key: 'required', errorText: 'Campo requerido' }],
    city: [{ key: 'required', errorText: 'Campo requerido' }],
    municipality: [{ key: 'required', errorText: 'Campo requerido' }],
    state: [{ key: 'required', errorText: 'Campo requerido' }]
};


class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            suppliers: props.supplier,
            errors: { ...errorsProps },
            openAlert: false
        };
    }

    updateSupplier(path, value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        const suppliers = setValueIn(parsePath(path), value, this.state.suppliers);
        this.setState({ suppliers, errors });
    }

    renderButtons(editing, supplier, onSave) {
        const { allowUpdate, allowDelete } = this.props;

        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, supplier, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state.suppliers);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowUpdate) { return; }
                            this.setState({ suppliers: supplier })
                            this.setState({ editing: true });
                            this.setState({ suppliers: supplier })
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowDelete) && <IconButton
                        tooltip="Eliminar Proveedor"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowDelete) { return; }
                            this.setState({ openAlert: true });
                        }}
                    >
                        <Trash />
                    </IconButton>
                }
            </div>
        );
    }

    render() {
        const { editing, errors } = this.state;
        const { supplier, executiveUsersList = [], onOpenInfoModal, onSave, actions } = this.props;
        const currentProperties = editing ? this.state.suppliers : supplier;
        const { name, taxId, address, executiveUser, edited } = currentProperties;
        return (
            <div style={{ marginBottom: 2 }} className="margin-bottom-2">
                <div className="col-md-12 main-card item-row">
                    <div className="row">
                        <div
                            className="col-lg-10 col-md-9 col-sm-6 col-xs-12 tabulador hidden-md-down"
                            style={{ minHeight: '3.6rem' }}
                            onClick={onOpenInfoModal}
                        >
                        </div>
                        <div
                            className="col-lg-2 col-md-3 col-sm-6 col-xs-12 card-buttons hidden-md-down"
                            style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}
                        >
                            {this.renderButtons(editing, supplier, onSave)}
                        </div>
                    </div>
                    <div className="row white-card padding-2">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-xs-12 col-sm-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        value={name}
                                        label="Nombre o Razón Social"
                                        fieldClass="nombre-cliente"
                                        notify={(value) => this.updateSupplier('name', value, 'name')}
                                        errorText={errors.name.join(' | ')}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="RFC"
                                        value={taxId}
                                        notify={(value) => this.updateSupplier('taxId', value, 'taxId')}
                                        errorText={errors.taxId.join(' | ')}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Calle"
                                        value={address.street}
                                        notify={(value) => this.updateSupplier('address>street', value, 'street')}
                                        errorText={errors.street.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Número Exterior"
                                        value={address.externalNumber}
                                        notify={(value) => this.updateSupplier('address>externalNumber', value, 'externalNumber')}
                                        errorText={errors.externalNumber.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Número Interior"
                                        value={address.internalNumber}
                                        notify={(value) => this.updateSupplier('address>internalNumber', value, 'internalNumber')}
                                        errorText={errors.internalNumber.join(' | ')}

                                    />                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Código Postal"
                                        value={address.zipCode}
                                        notify={(value) => this.updateSupplier('address>zipCode', value, 'zipCode')}
                                        errorText={errors.zipCode.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Colonia"
                                        value={address.colony}
                                        notify={(value) => this.updateSupplier('address>colony', value, 'colony')}
                                        errorText={errors.colony.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Ciudad"
                                        value={address.city}
                                        notify={(value) => this.updateSupplier('address>city', value, 'city')}
                                        errorText={errors.city.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Municipio"
                                        value={address.municipality}
                                        notify={(value) => this.updateSupplier('address>municipality', value, 'municipality')}
                                        errorText={errors.municipality.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        label="Estado"
                                        value={address.state}
                                        notify={(value) => this.updateSupplier('address>state', value, 'state')}
                                        errorText={errors.state.join(' | ')}

                                    />
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                    <EditableInlineV2
                                        editViewActive={editing}
                                        type="autocomplete"
                                        label="País"
                                        value={address.country != null ? getValueFromSelectList(COUNTRY_LIST.items, address.country).name : ""}
                                        items={COUNTRY_LIST.items}
                                        notify={(item) => {
                                            this.updateSupplier('address>country', item.id, 'country');
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-2 col-sm-6 col-md-6 hidden-lg-up" />
                        <div
                            className="col-xs-4 col-sm-3 col-md-3 tabulador hidden-lg-up"
                            style={{ minHeight: '3.6rem' }}
                        >
                        </div>
                        <div
                            className="col-xs-6 col-sm-3 col-md-3 card-buttons hidden-lg-up"
                            style={{ minHeight: '3.6rem', paddingTop: '0.8rem', marginBottom: '2rem' }}
                        >
                            {this.renderButtons(editing, supplier, onSave)}
                        </div>
                    </div>
                    <Alert
                        open={this.state.openAlert}
                        close={() => this.setState({ openAlert: false })}
                        message={"Seguro que quieres eliminar este Proveedor?"}
                        delteEntry={() => {
                            this.setState({ openAlert: false });
                            actions.deleteSupplier(supplier);
                        }}
                    />
                </div>
            </div>
        );
    }
}
export default Item;



// WEBPACK FOOTER //
// ./containers/proveedores/components/item.js